module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-115.7ed0e22e.svg";